const initialState = {
  cartItems: [],
  loading: false,
  error: null,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case "add_to_cart_request":
    case "update_cart_request":
      return { ...state, loading: true };

    case "add_to_cart_success":
    case "update_cart_success":
      return {
        ...state,
        loading: false,
      };

    case "cart_list_success":
      return { ...state, loading: false, cartItems: action.payload };
    case "delete_cart_success":
      return { ...state, isLoading: false, cartItems: action.payload };

    case "clear_cart_success":
      return { ...state, loading: false, cartItems: [] };

    case "add_to_cart_failure":
    case "update_cart_failure":
    case "cart_list_failure":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export { productReducer };
